import type { Destinations as DestinationsData } from "@/queries/getDestinations";
import type { ReactNode } from "react";
import { DestinationGrid } from "../destinationsGrid";
import { Side } from "./Side";

type Props = {
  destinations: DestinationsData;
  catalogueImage: ReactNode;
};
export const Destinations = ({ destinations, catalogueImage }: Props) => (
  <div className="flex gap-6 py-10 container">
    <div className="flex-1">
      <DestinationGrid destinations={destinations} />
    </div>
    <Side catalogueImage={catalogueImage} />
  </div>
);
